export default "__VITE_ASSET__B_nI85Zb__"